import React from 'react'

const SvgFootFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M12.563 2c.96 0 1.698.846 1.57 1.796l-.565 4.22-.335 2.438c-.112.787-.246 1.69-.46 3.125-.578 3.858 3.834 4.838 6.41 4.838 2.577 0 2.13 3.146.413 3.583H7.453s-.556-.627 0-3.158a25 25 0 01.468-1.831c.18-.618.206-.704.044-1.326-.188-.722-.417-2.228-.66-3.824-.195-1.291-.4-2.643-.6-3.686C6.7 8.165 6 5.497 6 4.055c0-.24.038-.711.105-1.148C6.197 2.314 6.711 2 7.312 2h5.251zm-2.33 15.781a.5.5 0 00-.505.494c-.007.56.138 1.074.515 1.444.375.367.897.511 1.474.511a.5.5 0 000-1c-.423 0-.651-.105-.774-.225-.12-.117-.22-.329-.216-.719a.5.5 0 00-.495-.505z' />
  </svg>
)

export default SvgFootFilled
